package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.repository.GameRepository

class DeleteGameUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(gameId: Long): Result<Unit> {
        return repository.deleteGame(gameId)
    }
}
